import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, array_type, union_type, class_type, string_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Quickfinder_Information_$reflection, Quickfinder_QuickfinderResponse_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RechnungQuickfinder", "RechnungQuickfinderById"];
    }
}

export function Page_$reflection() {
    return union_type("Quickfinder.Types.Page", [], Page, () => [[["Item", string_type]], [["Item1", string_type], ["Item2", class_type("System.Guid")]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadRechnungDetails", "SelectRechnung", "RechnungDetailsLoaded", "InformationenLoaded", "SortierungAendern", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Quickfinder.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Quickfinder_QuickfinderResponse_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Quickfinder_QuickfinderResponse_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Quickfinder_Information_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", array_type(Quickfinder_Information_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(Rechnungsnummer, AufsteigendSortieren, Information, QuickfinderResponse) {
        super();
        this.Rechnungsnummer = Rechnungsnummer;
        this.AufsteigendSortieren = AufsteigendSortieren;
        this.Information = Information;
        this.QuickfinderResponse = QuickfinderResponse;
    }
}

export function Model_$reflection() {
    return record_type("Quickfinder.Types.Model", [], Model, () => [["Rechnungsnummer", string_type], ["AufsteigendSortieren", bool_type], ["Information", Remote$1_$reflection(array_type(Quickfinder_Information_$reflection()))], ["QuickfinderResponse", Remote$1_$reflection(Quickfinder_QuickfinderResponse_$reflection())]]);
}

//# sourceMappingURL=Types.fs.js.map
